// extracted by mini-css-extract-plugin
module.exports = {"style":"_2HGKuJ7QWPjvbGcOTLdMoI"};